<template>
  <div class="chart-container-inner">
    <Bar :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import { 
  Chart as ChartJS, Title, Tooltip, Legend, BarElement, 
  CategoryScale, LinearScale 
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'BarChartFinance',
  components: { Bar },
  
  // 1. Recebe os dados da API enviados pelo componente pai (dashboard-index)
  props: {
    apiData: {
      type: Object,
      required: true
    }
  },

  // 2. Computed property: atualiza os dados do gráfico automaticamente
  computed: {
    chartData() {
      return {
        labels: this.apiData.labels, // Ex: ['Jan', 'Fev', 'Mar'...]
        datasets: [
          {
            label: 'Receitas',
            backgroundColor: 'rgba(16, 185, 129, 0.7)', // Verde Esmeralda translúcido
            hoverBackgroundColor: '#10b981',            // Fica mais forte no hover
            borderRadius: 6,
            borderSkipped: false,
            barPercentage: 0.6,
            categoryPercentage: 0.8,
            data: this.apiData.incomes // Array dinâmico com os totais de Receita
          },
          {
            label: 'Despesas',
            backgroundColor: 'rgba(244, 63, 94, 0.7)',  // Rosa Coral translúcido
            hoverBackgroundColor: '#f43f5e',            // Fica mais forte no hover
            borderRadius: 6,
            borderSkipped: false,
            barPercentage: 0.6,
            categoryPercentage: 0.8,
            data: this.apiData.expenses // Array dinâmico com os totais de Despesa
          }
        ]
      }
    }
  },

  // 3. Opções de design e formatação
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false, // ESSENCIAL para preencher o cartão do dashboard
        interaction: {
          mode: 'index',
          intersect: false,
        },
        plugins: {
          legend: { 
            position: 'top', 
            align: 'end',
            labels: {
              usePointStyle: true,
              boxWidth: 8,
              color: '#64748b',
              font: { family: "'Inter', sans-serif", size: 12, weight: '500' }
            }
          },
          tooltip: {
            backgroundColor: 'rgba(30, 41, 59, 0.9)',
            padding: 12,
            cornerRadius: 8,
            callbacks: {
              // Formata os números do tooltip para Moeda (R$)
              label: function(context) {
                let label = context.dataset.label || '';
                if (label) { label += ': '; }
                if (context.parsed.y !== null) {
                  label += new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(context.parsed.y);
                }
                return label;
              }
            }
          }
        },
        scales: {
          x: { 
            grid: { display: false, drawBorder: false },
            ticks: { color: '#94a3b8', font: { size: 11 } }
          },
          y: { 
            border: { display: false },
            grid: { color: '#f1f5f9', drawTicks: false },
            ticks: { 
              color: '#94a3b8', 
              font: { size: 11 }, 
              padding: 10,
              // Formata os números do eixo Y (Ex: 2500 transforma-se em 2.5k) para poupar espaço visual
              callback: function(value) {
                if (value >= 1000) return (value / 1000).toFixed(1).replace('.0', '') + 'k';
                return value;
              }
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.chart-container-inner {
  position: relative;
  height: 100%;
  width: 100%;
}
</style>